<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-8">
                  <h4 class="card-title">Makinalar</h4>
                  <p class="card-category">Elinizdeki makinaları buradan daha kolay yönetebilirsiniz. Envanterinizi
                    burada
                    tutup, müşterilerinize daha kolay gösterirsiniz. Aktif ve pasif makinalarınızı buradan
                    düzenleyebilirsiniz.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-light btn-fill float-right" @click="syncItems()">
                    Senkronize Et
                  </button>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>

              </div>



              <div class="row p-3">
                <div class="col-3 ml-2">
                  <input class="form-control form-control-lg bg-light text-dark placeholder-dark"
                    @input="debounceGetCategories" v-model="queryText" type="text" placeholder="Arama">
                </div>

              </div>


            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.brand }}</td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.modelName }}</td>
                    <td>{{ item.modelYear }}</td>
                    <td>{{ item.category ? item.category.name : '-' }}</td>
                    <td>{{ item.isActive ? 'Evet' : 'Hayır' }}<div class="text-muted text-sm"
                        v-if="item.websiteListIndex">(#{{
                          item.websiteListIndex }})</div>
                    </td>
                    <td>{{ statusesMap[item.status] }}</td>
                    <td>{{ item.sourceType === "INTERNAL" ? 'Manual' : `${item.source} (${item.sourceId})` }}</td>
                    <td @click="openDeleteModal(item)"><button><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td @click="editItem(item._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button></td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i +
                    1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.item">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Ürünü silmek istediğinize emin misiniz? Durumu pasife
                  çekerek gizleyebilirsiniz.</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal.isOpened = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Ürün Adı:</strong> {{ deleteModal.item.title }}</label><br>
                <label><strong>Marka:</strong> {{ deleteModal.item.brand }}</label><br>
                <label><strong>Model Adı:</strong> {{ deleteModal.item.modelName }}</label><br>
                <label><strong>Model Yılı:</strong> {{ deleteModal.item.modelYear }}</label><br>
                <label><strong>Kategori:</strong> {{ deleteModal.item.category ? deleteModal.item.category.name : '-'
                  }}</label><br>
                <label><strong>Listede mi?:</strong> {{ deleteModal.item.isActive ? 'Evet' : 'Hayır'
                  }}<span></span></label><br>
              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteItem(deleteModal.item._id)" class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

const statusesMap = {
  'active': 'Aktif',
  'sold': 'Satıldı',
  'pending': 'Beklemede',
  'inactive': 'Pasif',
  'rented': 'Kiralandı',
  'maintenance': 'Tamirde',
  'other': 'Diğer',
}

const tableColumns = ['Marka', 'Ürün Adı', 'Model Adı', 'Model Yılı', 'Kategori', 'Listede mi?', 'Durum', 'Kaynak', 'Sil', 'Düzenle']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      categories: [],
      items: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      queryText: '',
      deleteModal: {
        isOpened: false,
        item: null
      },
      searchInterval: null,
      statusesMap
    }
  },
  mounted() {
    this.getCategories();
    this.getItems();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getItems();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getCategories() {

      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000 }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('category', query).then((res) => {
        if (res.success == true) {
          this.categories = res.categories;
        } else {
          console.log('error');
        }
      })
    },
    getItems() {
      let q = { title: { $regex: this.queryText, $options: 'i' } };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('item', query).then((res) => {
        if (res.success == true) {
          this.items = res.items;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteItem(_id) {
      CollectionService.deleteItem('item', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.item.title} ürün silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.item = null;
        this.getItems();
      })
    },
    openDeleteModal(item) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.item = item;
    },
    editItem(_id) {
      this.$router.push(`/admin/items/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/items/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    debounceGetCategories() {
      if (this.searchInterval) {
        clearTimeout(this.searchInterval);
      }
      this.searchInterval = setTimeout(() => {
        this.getItems();
      }, 250);
    },
    syncItems() {
      this.notifyVue('top', 'right', 'info', 'Makinalar senkronize ediliyor, lütfen bekleyiniz...');

      CollectionService.getCollection('item/sync').then((res) => {
        this.notifyVue('top', 'right', 'success', res.message);
        this.getItems();
      }).catch((err) => {
        this.notifyVue('top', 'right', 'danger', 'Makinalar senkronize edilirken bir hata oluştu.');
      })
    }
  }
}
</script>
<style>
.text-muted {
  font-size: 14px;
}
</style>